let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g9079")).then(() => parcelRequire('9HHke'));